/**
 * document-routes
 * com.ksoft
 *
 * OpenAPI spec version: 1.1
 * Contact: fposada@ksoftonline.co
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class IngestaDeDocumentosService {

    protected basePath = 'http://localhost:8083/dr';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Obtener estado de documento
     * Consulta el estado de procesamiento de un documento por su ID
     * @param documentId ID del documento
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDocumentStatus(documentId: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getDocumentStatus(documentId: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getDocumentStatus(documentId: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getDocumentStatus(documentId: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling getDocumentStatus.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/documents/${encodeURIComponent(String(documentId))}/status`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pingDocument(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pingDocument(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pingDocument(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pingDocument(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/documents/ping`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Recibir documento de WhatsApp
     * Endpoint para recibir documentos y metadatos a través de la integración con WhatsApp.
     * @param body Datos del documento de WhatsApp en formato JSON
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public receiveWhatsappDocument(body: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public receiveWhatsappDocument(body: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public receiveWhatsappDocument(body: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public receiveWhatsappDocument(body: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling receiveWhatsappDocument.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/documents/whatsapp`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Cargar un documento
     * Permite cargar un documento a través de una interfaz web, incluyendo metadatos adicionales.
     * @param file 
     * @param solicitudId ID de la solicitud asociada
     * @param tipoDocumento Tipo de documento
     * @param observaciones Observaciones adicionales
     * @param canalOrigen Canal de origen
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadDocumentForm(file?: any, solicitudId?: any, tipoDocumento?: any, observaciones?: any, canalOrigen?: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public uploadDocumentForm(file?: any, solicitudId?: any, tipoDocumento?: any, observaciones?: any, canalOrigen?: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public uploadDocumentForm(file?: any, solicitudId?: any, tipoDocumento?: any, observaciones?: any, canalOrigen?: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public uploadDocumentForm(file?: any, solicitudId?: any, tipoDocumento?: any, observaciones?: any, canalOrigen?: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;
        if (solicitudId !== undefined && solicitudId !== null) {
            headers = headers.set('solicitudId', String(solicitudId));
        }
        if (tipoDocumento !== undefined && tipoDocumento !== null) {
            headers = headers.set('tipoDocumento', String(tipoDocumento));
        }
        if (observaciones !== undefined && observaciones !== null) {
            headers = headers.set('observaciones', String(observaciones));
        }
        if (canalOrigen !== undefined && canalOrigen !== null) {
            headers = headers.set('canalOrigen', String(canalOrigen));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        return this.httpClient.request<any>('post',`${this.basePath}/documents/upload`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Cargar múltiples documentos de forma asíncrona
     * Permite cargar varios documentos a la vez. El sistema acepta los archivos y los procesa en segundo plano.
     * @param pid ID de persona
     * @param files 
     * @param solicitudId ID de la solicitud asociada a todos los documentos
     * @param tipoDocumento Tipo de documento para todos los archivos
     * @param observaciones Observaciones generales
     * @param canalOrigen Canal de origen
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadMultipleDocumentsForm(pid: any, files?: any, solicitudId?: any, tipoDocumento?: any, observaciones?: any, canalOrigen?: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public uploadMultipleDocumentsForm(pid: any, files?: any, solicitudId?: any, tipoDocumento?: any, observaciones?: any, canalOrigen?: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public uploadMultipleDocumentsForm(pid: any, files?: any, solicitudId?: any, tipoDocumento?: any, observaciones?: any, canalOrigen?: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public uploadMultipleDocumentsForm(pid: any, files?: any, solicitudId?: any, tipoDocumento?: any, observaciones?: any, canalOrigen?: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling uploadMultipleDocuments.');
        }






        let headers = this.defaultHeaders;
        if (solicitudId !== undefined && solicitudId !== null) {
            headers = headers.set('solicitudId', String(solicitudId));
        }
        if (tipoDocumento !== undefined && tipoDocumento !== null) {
            headers = headers.set('tipoDocumento', String(tipoDocumento));
        }
        if (observaciones !== undefined && observaciones !== null) {
            headers = headers.set('observaciones', String(observaciones));
        }
        if (canalOrigen !== undefined && canalOrigen !== null) {
            headers = headers.set('canalOrigen', String(canalOrigen));
        }
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (files !== undefined) {
            formParams = formParams.append('files', <any>files) as any || formParams;
        }

        return this.httpClient.request<any>('post',`${this.basePath}/documents/upload-multiple`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
